import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  InputAdornment,
  InputBase,
  Button,
  Link,
  Dialog,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import axios from "axios";
import SearchIcon from "@material-ui/icons/Search";
import { CloudUpload } from "@material-ui/icons";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DataService from "../../../../Service";
import { ObjectToFormdata } from "../../../../Common/Utils/common_utils";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularIndeterminate from "../../../../Components/Loader";
import GetAppIcon from "@material-ui/icons/GetApp";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import fileDownload from "js-file-download";
import { showSnackbar } from "../../../../Components/Snackbar/SnackbarActions";
import { useDispatch, useSelector } from "react-redux";

function Thematic(props) {
  const [docData, setDocData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [confirmationDialogOpen, setConfirmationDialogOpen] =
    React.useState(false);
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [currentID, setcurrentID] = React.useState(0);
  const globaluserData = useSelector((state) => state.commonReducer);
  console.log("global user data", globaluserData);
  const organisationId = globaluserData?.organisation_id
  // const organisationId = sessionStorage.getItem("organisation_id");
  const dispatch = useDispatch();

  useEffect(() => getDocument(), []);

  const handleClickConfirmationOpen = () => {
    setConfirmationDialogOpen(true);
  };

  const handleConfirmationClose = () => {
    setConfirmationDialogOpen(false);
  };

  const getDocument = (params) => {
    setLoading(true);
    DataService.getDirectData(
      "thematics/listing_documents?organisation_id=" + organisationId,
      {}
    )
      .then((res) => {
        setLoading(false);
        docData.length = 0;
        setDocData(docData.concat(res.thematic_documents));
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const uploadDoc = (event, id) => {
    setLoading(true);
    var postData = {
      organisation_id: organisationId,
      "documents[]": event.target.files[0],
    };
    DataService.createData(ObjectToFormdata({ ...postData }), "thematicsDoc")
      .then((response) => {
        setLoading(false);
        getDocument();
        dispatch(showSnackbar("Success", ["File uploaded successfully"]));

        var localArr = [];
        localArr.push(response.thematic_documents);
        setDocData(docData.concat(localArr));
      })
      .catch(() => {});
  };

  const deleteDoc = (id) => {
    setLoading(true);
    DataService.deleteDirectFeild(
      "thematics/delete_document?organisation_id=" +
        organisationId +
        "&document_id=" +
        id,
      {}
    )
      .then((response) => {
        setLoading(false);
        var localArr = docData.filter((option) => option?.id !== id);
        docData.length = 0;
        setDocData(docData.concat(localArr));
        dispatch(showSnackbar("Success", ["File removed successfully"]));
      })
      .catch(() => {});
  };

  const downloadFile = async (fileName) => {
    axios
      .get(fileName, {
        responseType: "blob", // Set the response type to 'blob' to handle binary data
      })
      .then((response) => {
        // Create a blob from the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create a link element to trigger the download
        const a = document.createElement("a");
        a.href = url;
        a.download = "document.pdf"; // Set the desired file name here
        document.body.appendChild(a);

        // Trigger the download
        a.click();

        // Clean up by revoking the temporary URL
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading PDF:", error);
      });
  };

  return (
    <Box p={3} alignItems="center">
      <Box mt={1}>
        <Grid container direction="row" alignItems="center">
          <Grid item xs={4}>
            <Typography variant="h1" style={{ color: "#077f83" }}>
              <Box fontWeight="fontWeightBold">Uploaded documents</Box>
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Box textAlign="left">
              <label htmlFor="upload-photo-passport">
                <input
                  onChange={(e) => {
                    const file = e.target.files[0];
                    const supportedFormats = [
                      "application/pdf",
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                      "text/plain",
                    ];
                    console.log(file, "files");

                    if (file && file.type) {
                      if (supportedFormats.includes(file.type)) {
                        uploadDoc(e);
                      } else {
                        dispatch(
                          showSnackbar(
                            "error",
                            [
                              "Unsupported file format",
                              "Only supports .pdf,.doc,.docx,.txt",
                            ],
                            1000
                          )
                        );
                      }
                    }
                  }}
                  accept="application/pdf,
                  .doc,.docx,
                  text/plain"
                  style={{ display: "none" }}
                  id="upload-photo-passport"
                  name="upload-photo"
                  type="file"
                />
                <Button
                  variant="contained"
                  component="span"
                  style={{
                    fontSize: 14,
                    backgroundColor: "#EF7000",
                    color: "#fff",
                    textTransform: "none",
                  }}
                >
                  <CloudUpload style={{ marginRight: 10 }} />
                  Upload
                </Button>
              </label>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box mt={5}>
        <Grid container direction="row" spacing={2} alignItem="center">
          <Grid item xs={4}>
            {docData.length > 0 &&
              docData.map((option) => {
                return (
                  <Box border={1} px={2} py={2} mb={2}>
                    <Grid
                      key={option?.id}
                      container
                      direction="row"
                      spacing={2}
                      alignItem="center"
                      justify="space-between"
                    >
                      <Grid item xs={9}>
                        <Link
                          href={option?.url}
                          target="_blank"
                          type="application/pdf"
                        >
                          <Typography variant="h6" style={{ color: "#4D4F5C" }}>
                            <Box textOverflow="ellipsis" overflow="hidden">
                              {option?.name}
                            </Box>
                          </Typography>
                        </Link>
                      </Grid>
                      <Grid item xs={3}>
                        <Box textAlign="right">
                          <SaveAltIcon
                            style={{ fill: "#000" }}
                            onClick={() => downloadFile(option.url)}
                          />

                          <DeleteIcon
                            onClick={() => {
                              setcurrentID(option?.id);
                              handleClickConfirmationOpen();
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                );
              })}
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Dialog
          onClose={handleConfirmationClose}
          aria-labelledby="confirmation-dialog-title"
          open={confirmationDialogOpen}
          maxWidth={maxWidth}
        >
          <DialogContent>
            <Box p={4}>
              <Typography variant="h5">
                <Box textAlign="center">Are you sure to delete?</Box>
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions
            disableSpacing={true}
            style={{ justifyContent: "center" }}
          >
            <Box px={4} pb={2}>
              <Button variant="contained" onClick={handleConfirmationClose}>
                No
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  handleConfirmationClose();
                  deleteDoc(currentID);
                }}
                style={{ marginLeft: 10 }}
              >
                Yes
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>
      {loading && <CircularIndeterminate />}
    </Box>
  );
}

export default Thematic;
